<script>
	import { fade } from 'svelte/transition';
	import { scaleAdOnHover, startAd, pauseAd, stopAd } from '../../../../share/ads';
	import { getText } from '../../../../share/utils';

	let ads = {
		// Heinrich_Schmid_ANI_V2_K2
		transporter: {
			element: false,
			fallbackImgUrl: './../video/Heinrich_Schmid_ANI_V2_K2_Posterbild.webp',
			imageAltText: 'Heinrich Schmid - interactive Ad',
			videoUrl: './../video/Heinrich_Schmid_ANI_V2_K2.mp4',
			playTimeMs: 19000,
			playing: false,
			autoStopTimeOut: false,
			pauseImgOffsetS: 1,
			scale: 1,
			volume: 0,
			origWidth: 1372,
			origHeight: 102,
			showPauseButton: false
		},
		// FLU0295A_Insta_Story_Ad_portground
		beard: {
			element: false,
			fallbackImgUrl: './../video/Bildschirmfoto 2021-11-04 um 12.23.20.webp',
			imageAltText: 'Beard - interactive Ad',
			videoUrl: './../video/Sequenz_01_1.mp4',
			playTimeMs: 24000,
			playing: false,
			autoStopTimeOut: false,
			pauseImgOffsetS: 4,
			scale: 1,
			volume: 0,
			origWidth: 990,
			origHeight: 556,
			showPauseButton: false
		}
	}
</script>

<div class="page-middleclass-miscellaneous marginbox">
	<div class="flex structure">
		<div class="flex row structure-1">
			<!-- Beginning - transporter -->
			<div bind:this={ads.transporter.element} class="flex element">
				<div use:scaleAdOnHover={ads.transporter} class="commercial" class:playing={ads.transporter.playing}
					 on:click={() => !ads.transporter.playing ? startAd(ads.transporter, () => ads = ads) : null}>
					<video playsinline loop="true"
						   on:loadeddata={() => stopAd(ads.transporter, () => ads = ads)}
						   on:mousemove={() => {ads.transporter.showPauseButton = true; setTimeout(() => {
								   ads.transporter.showPauseButton = false;
							   }, 2000)}}
						   scrolling="no"
						   src={ads.transporter.videoUrl}
					/>
					{#if ads.transporter.playing}
						<!-- PLAYING -->
						{#if ads.transporter.showPauseButton}
							<button aria-label="pause Ad - {ads.transporter.imageAltText}" transition:fade class="pausebutton"
									on:click={() => pauseAd(ads.transporter, () => ads = ads)}></button>
						{/if}
					{:else}
						<!-- NOT PLAYING -->
						<button aria-label="play Ad - {ads.transporter.imageAltText}" class="playbutton"></button>
					{/if}
				</div>
			</div>
			<!-- End - transporter -->
		</div>
		
		<div class="flex col structure-2">
			<div class="flex element">
				<img loading="lazy" alt="Kein Mittelmaß - Uhrinstinkt - Design" src="./../img/15.Kein_Mittelmass/08.miscellaneous/Uhrmacher.webp">
			</div>
			<div class="flex element">
				<div class="text">
					<h2 class="caption">{getText("15.08.01_h2")}</h2>
					<p class="caption">{getText("15.08.02_caption")}</p>
				</div>
			</div>
		</div>

		<div class="flex col structure-3">
			<!-- Beginning - beard -->
			<div bind:this={ads.beard.element} class="flex element">
				<div use:scaleAdOnHover={ads.beard} class="commercial" class:playing={ads.beard.playing} on:click={() =>
				!ads.beard.playing ? startAd(ads.beard, () => ads = ads) : null}>
					<video playsinline loop="true"
						   on:loadeddata={() => stopAd(ads.beard, () => ads = ads)}
						   on:mousemove={() => {ads.beard.showPauseButton = true; setTimeout(() => {
								   ads.beard.showPauseButton = false;
							   }, 2000)}}
						   scrolling="no"
						   src={ads.beard.videoUrl}
					/>
					{#if ads.beard.playing}
						<!-- PLAYING -->
						{#if ads.beard.showPauseButton}
							<button aria-label="pause Ad - {ads.beard.imageAltText}" transition:fade class="pausebutton"
									on:click={() => pauseAd(ads.beard, () => ads = ads)}></button>
						{/if}
					{:else}
						<!-- NOT PLAYING -->
						<button aria-label="play Ad - {ads.beard.imageAltText}" class="playbutton"></button>
					{/if}
				</div>
			</div>
			<!-- End - beard -->
		</div>
	</div>
</div>

<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";
	
	img {
		width: 100%;
		margin: 0;
		padding: 0;
	}
	
	.img-single {
		margin: $spacing-mobile $spacing-mobile $media-gap $spacing-mobile;
	}
	
	h2,
	h2 {
		margin-bottom: $media-gap;
	}
	
	.page-middleclass-miscellaneous {
		.flex {
			display: flex;
			box-sizing: border-box;
		}
		
		.row {
			flex-flow: row wrap;
		}
		
		.col {
			flex-flow: column wrap;
		}
		
		.element {
			min-width: 100px;
		}
		
		.commercial {
			position: relative;
			width: 100%;
			height: auto;
			line-height: 0	;
		}
		
		.content {
			flex: 1 100%;
		}
		
		.structure {
			flex-flow: row wrap;
		}
		
		.structure-1,
		.structure-2,
		.structure-3 {
			width: 100%;
			padding: 0;
			position: relative;
			
			> .element {
				width: 100%;
				margin-bottom: $media-gap;
				height: fit-content;
			}
		}
		
		.structure-2 {
			margin-bottom: $media-gap;

			@include for-tablet-portrait-up {
				padding-right: $media-gap;
				width: 25%;
			}
		}
		
		.structure-3 {
			@include for-tablet-portrait-up {
				width: 75%;
			}
		}
		
		.text {
			margin: 0;
		}

		.commercial video {
			width: 100%;
			height: calc(var(--origHeight) * var(--scale));
			background-image: var(--bg-image);
			background-size: cover;
		}

		:global(.commercial video[loaded]) {
			background-image: none !important;
		}
	}
</style>
